module.exports = __webpack_public_path__ + "static/media/jacob.ff00f295.jpg";